export default string =>
  encodeURI(string.trim().toLowerCase().split(' ').join('-'));
